import travelKit from './initial/flow';

const TravelKitFlows = {
  travelKit
};

export default TravelKitFlows;
